import { apolloClient } from "@td/ui";
import FETCH_PRE_INTAKE_STATUSES_QUERY from "../queries/fetch-pre-intake-statuses.graphql";

export const fetchPreIntakeStatuses = async () => {
  const { data: { preIntakeStatuses: data } } = await apolloClient.query({
    query: FETCH_PRE_INTAKE_STATUSES_QUERY,
  });

  return data;
};
